module.exports = __webpack_public_path__ + "static/media/negotiation.743e9c73.svg";